import { S3_IMAGES_URL } from "constants/index";
import React, { useEffect } from "react";

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "##063970",
    color: "#f0f0f0",
    borderRadius: "8px",
    maxWidth: "1000px",
    margin: "0 auto",
  },
  section: {
    marginBottom: "40px",
  },
  title: {
    fontSize: "2.5rem",
    color: "#ffffff",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "1.5rem",
    color: "#f0f0f0",
    marginBottom: "15px",
    borderBottom: "1px solid #333",
    paddingBottom: "5px",
  },
  list: {
    listStyleType: "disc",
    paddingLeft: "20px",
  },
  link: {
    color: "#61dafb",
    textDecoration: "underline",
    marginLeft: "5px",
  },
  highlight: {
    fontWeight: "bold",
    color: "#FFD700",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    backgroundColor: "#102040", // main table background
    borderRadius: "5px",
    overflow: "hidden",
  },
  th: {
    backgroundColor: "#1c2d50", // header background
    padding: "12px",
    textAlign: "left",
    borderBottom: "1px solid #444",
    color: "#FFD700", // golden yellow

  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #2a2a2a",
    color: "#E0E8F0", // light soft blue-gray
    backgroundColor: "#152647", // row background
  },
  imageSection: {
    display: "flex",
    padding: "20px",
    boxSizing: "border-box",
    marginLeft: "10%",
    marginTop: "-5%",
    cursor:"pointer"
  },
  image: {
    width: "100%",
    maxWidth: "200px",
    height: "auto",
    borderRadius: "8px",
    objectFit: "contain",
  },

  responsive: `
  @media screen and (max-width: 600px) {
    h1 { font-size: 2rem !important; }
    h2 { font-size: 1.25rem !important; }
    ul, ol { padding-left: 16px !important; }
    table {
      width: 100%;
    }
    th, td {
      white-space: nowrap;
    }
  }
`,
};


const NGBTokenPage = () => {
    useEffect(() => {
    if (window.location.pathname === "/crypto-future") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);


  return (
    <>
      <style>{styles.responsive}</style>
      <div style={styles.container}>
        {/* Section 1 */}
        <div style={styles.section}>
          <h1 style={styles.title}>The #NGB Token</h1>
          <p>Your key to the NextGen Virtual World</p>
        </div>

        {/* Section 2 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>What is #NGB?</h2>
          <ul style={styles.list}>
            <li>The official cryptocurrency of NextGenBets</li>
            <li>
              Powers our upcoming Virtual World sportsbook & casino platform
            </li>
            <li>
              Not yet live for betting — launching in Phase 2 with full utility
            </li>
            <li>Buy and trade now on Dexscreener — get in early!</li>
          </ul>
        </div>

        {/* Section 3 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>Why Buy #NGB Now?</h2>
          <ul style={styles.list}>
            <li>
              Exclusive perks: future staking, hosting casino nights, NFT drops
              & more
            </li>
            <li>Early access: Prelaunch invite to the NGB Virtual World</li>
            <li>
              Earn future revenue share: Virtual World net gaming revenue
              distributed monthly to holders
            </li>
            <li>Community power: Help shape the future</li>
            <li>
              Long-term growth: Be ready for the surge in demand once Phase 2
              launches
            </li>
          </ul>
        </div>

        {/* Section 4 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>How to Buy</h2>
          <ol style={styles.list}>
            <li>Set up a wallet (MetaMask, Phantom, etc.)</li>
            <li>Purchase SOL or USDT on exchanges like Binance or Coinbase</li>
            <li>Visit Dexscreener and search for NGB</li>
            <li>
              Swap SOL for <span style={styles.highlight}>$NGB</span> on
              supported DEXs (Jupiter, Raydium)
            </li>
            <li>
              Hold and get ready to unlock full benefits with Phase 2 launch
            </li>
          </ol>
          <p>
            Buy <span style={styles.highlight}>$NGB</span> on Dexscreener:
            <a
              href="https://dexscreener.com/solana/8Qw1ENy338WEJkHkaXS8CvuE85bq4frFjLUy9fZa8A22"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              #NGB $0.0₅8025 – NextGen Bets 🎈 / SOL on Solana / Raydium
            </a>
          </p>
        </div>

        {/* Section 5 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>Tokenomics At a Glance</h2>
          <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Attribute</th>
                  <th style={styles.th}>Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.td}>Token Name</td>
                  <td style={styles.td}>NextGenBets Token</td>
                </tr>
                <tr>
                  <td style={styles.td}>Symbol</td>
                  <td style={styles.td}>$NGB</td>
                </tr>
                <tr>
                  <td style={styles.td}>Blockchain</td>
                  <td style={styles.td}>Solana</td>
                </tr>
                <tr>
                  <td style={styles.td}>Total Supply</td>
                  <td style={styles.td}>100 Billion</td>
                </tr>
                <tr>
                  <td style={styles.td}>Locked Liquidity</td>
                  <td style={styles.td}>Yes</td>
                </tr>
                <tr>
                  <td style={styles.td}>Rewards Pool</td>
                  <td style={styles.td}>Revenue share</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Section 6 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>
            Coming in Phase 2 (Virtual World Launch)
          </h2>
          <ul style={styles.list}>
            <li>Full betting & casino play with $NGB</li>
            <li>Monthly cashback & rewards for token holders</li>
            <li>Host your own casino nights</li>
            <li>Staking pools and NFTs</li>
            <li>Token holder governance rights</li>
          </ul>
        </div>

        {/* Section 7 */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>Join the #NGB Community</h2>
          <p>
            Follow us and stay informed:
            <br />
            <a href="https://t.me/NextGenBetsNGB" style={styles.link}>
              Telegram
            </a>{" "}
            |
            <a href="https://www.nextgenbets.com" style={styles.link}>
              {" "}
              Website
            </a>
          </p>
        </div>

        {/* Final CTA */}
        <div style={styles.section}>
          <h2 style={styles.subtitle}>
            Get in early — Own the future of betting with{" "}
            <span style={styles.highlight}>#NGB</span>.
          </h2>
        </div>
      </div>

      {/* Section 8: Promotional Image */}
      <div style={styles.imageSection} onClick={()=>{
        window.open('https://dexscreener.com/solana/8Qw1ENy338WEJkHkaXS8CvuE85bq4frFjLUy9fZa8A22','_blank')
      }}>
        <img
          src={`${S3_IMAGES_URL.IMAGE_URL}/banner/ngb-token-pr.png`}
          alt="NextGen Virtual World"
          style={styles.image}
        />
      </div>
    </>
  );
};

export default NGBTokenPage;
